export default __webpack_public_path__ + "static/media/event.9e147a02.jpg";